import React from 'react'
import './DashboardFooter.css'
import { appConfig } from '../../config/appConfig';


const DashboardFooter = () => {
  return (
    <footer className='dashboard-footer'>
        
        <h6 className="dashboard-footer-right">
            &copy;{new Date().getFullYear()} {appConfig.appName}. All rights reserved.
        </h6>
    </footer>
  )
}

export default DashboardFooter
